import * as Sentry from "@sentry/react";

type LogLevel = "debug" | "info" | "warn" | "error";

export interface LogContext {
  [key: string]: unknown;
}

const log = (level: LogLevel, message: string, context?: LogContext) => {
  if (import.meta.env.PROD && level === "debug") return;
  const payload = context ? { ...context } : undefined;
  const fn =
    level === "error"
      ? console.error
      : level === "warn"
        ? console.warn
        : level === "info"
          ? console.info
          : console.debug;
  if (payload) fn(`[${level}] ${message}`, payload);
  else fn(`[${level}] ${message}`);
};

export const logger = {
  debug: (message: string, context?: LogContext) => log("debug", message, context),
  info: (message: string, context?: LogContext) => log("info", message, context),
  warn: (message: string, context?: LogContext) => log("warn", message, context),
  error: (message: string, context?: LogContext) => log("error", message, context),
};

export const captureError = (error: unknown, context?: LogContext) => {
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : "unknown error";
  logger.error(message, { ...context, error });
  // handled 에러를 Sentry 로 전송한다(uncaught 는 전역/React root 핸들러가 담당).
  // Sentry 미초기화(로컬 dev·비배포 빌드)면 no-op. 텔레메트리 실패가 앱 경로를 교란하지 않게 삼킨다.
  try {
    Sentry.captureException(error, context ? { extra: context } : undefined);
  } catch {
    // 텔레메트리 오류는 무시 — API/앱 흐름에 영향 주지 않는다.
  }
};
